import { checkSupportsInterface } from '../core';
import { v5SupportInterfaceIds, v5Contracts } from '../token-registry-v5';
import { v4SupportInterfaceIds, v4Contracts } from '../token-registry-v4';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const ownerOf = /* @__PURE__ */ __name(async (contractOptions, signer, params, options) => {
  const { tokenRegistryAddress } = contractOptions;
  const { titleEscrowVersion } = options;
  const { tokenId } = params;
  if (!tokenRegistryAddress) throw new Error("Token registry address is required");
  if (!signer.provider) throw new Error("Provider is required");
  let isV5TT = titleEscrowVersion === "v5";
  let isV4TT = titleEscrowVersion === "v4";
  if (titleEscrowVersion === void 0) {
    [isV4TT, isV5TT] = await Promise.all([
      checkSupportsInterface(tokenRegistryAddress, v4SupportInterfaceIds.SBT, signer.provider),
      checkSupportsInterface(tokenRegistryAddress, v5SupportInterfaceIds.SBT, signer.provider)
    ]);
  }
  if (!isV4TT && !isV5TT) {
    throw new Error("Only Token Registry V4/V5 is supported");
  }
  let tradeTrustTokenContract;
  if (isV5TT) {
    tradeTrustTokenContract = v5Contracts.TradeTrustToken__factory.connect(
      tokenRegistryAddress,
      signer
    );
  } else if (isV4TT) {
    tradeTrustTokenContract = v4Contracts.TradeTrustToken__factory.connect(
      tokenRegistryAddress,
      signer
    );
  }
  if (isV5TT) {
    return await tradeTrustTokenContract.ownerOf(tokenId);
  } else if (isV4TT) {
    return await tradeTrustTokenContract.ownerOf(tokenId);
  }
}, "ownerOf");

export { ownerOf };
